var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer bg-white py-4 d-flex flex-lg-column",
    attrs: {
      "id": "kt_footer"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row align-items-center justify-content-between",
    class: {
      'container-fluid': _vm.widthFluid,
      container: !_vm.widthFluid
    }
  }, [_c('div', {
    staticClass: "nav nav-dark order-1 order-md-2"
  }, [_vm.showPdvShortcuts ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-atalhos-pdv",
      modifiers: {
        "modal-atalhos-pdv": true
      }
    }],
    staticClass: "nav-link pr-3 pl-0 footer-shortcuts-link",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Atalhos ")]) : _vm._e(), _vm.isClienteNutsDireto ? _c('a', {
    staticClass: "nav-link pr-3 pl-0",
    attrs: {
      "href": "/#/termos",
      "target": "_blank"
    }
  }, [_vm._v("Termos")]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };